module.exports = __webpack_public_path__ + "static/media/extend3.1b74dd7e.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/extend3.png
// module id = 2021
// module chunks = 0